import {Component, computed, inject, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IItem} from '../../../../../../types/IItem';
import {IconsComponent} from '../../../../../../shared/components/icons/icons.component';
import {LinkComponent} from '../../../../../../shared/components/link/link.component';
import {TooltipComponent} from '../../../../../../shared/components/tooltip/tooltip.component';
import {ItemImageComponent} from '../../../../../../shared/components/item-image/item-image.component';
import {AppStore} from '../../../../../../shared/store/app.store';
import {AccessService} from '../../../../../../shared/services/access.service';

@Component({
  selector: 'app-results-table-row-image',
  standalone: true,
  imports: [CommonModule, IconsComponent, LinkComponent, TooltipComponent, ItemImageComponent],
  templateUrl: './results-table-row-image.component.html',
  styleUrl: './results-table-row-image.component.css'
})
export class ResultsTableRowImageComponent {
  item = input.required<IItem>();
  isSpecial = input<boolean>(false);

  openModal = output();

  appStore = inject(AppStore);
  access = inject(AccessService);
  imageSize = computed(() => ({ xs: '120', sm: '120' } as Record<string, string>)[this.appStore.currentBreakpoint()] ?? '35');
}
